import { AbstractOpinionListPage } from '~/opinions/front/core/pages/AbstractOpinionListPage/AbstractOpinionListPage'
import OpinionListPageTemplate from '~/opinions/front/core/pages/OpinionListPage/OpinionListPage.vue'

class OpinionListPage extends AbstractOpinionListPage {
	static alias = 'opinion-list'
	component = OpinionListPageTemplate
}

export { OpinionListPage }
